import React, { Suspense } from "react";
const HealthCheckPageWrapper = React.lazy(() => import("../components/HealthCheckPageWrapper"));

function HealthCheckPage() {
  return (
    <Suspense
      fallback={
        <>
          Loading...
        </>
      }
    >
      <HealthCheckPageWrapper />
    </Suspense>
  );
}

export default HealthCheckPage;
